/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as Mentor_profileRouteImport } from './routes/_mentor_profile'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as Admin_chatRouteImport } from './routes/_admin_chat'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUpcomingRouteImport } from './routes/_authenticated/upcoming'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedReferralsRouteImport } from './routes/_authenticated/referrals'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedMentorDataDashboardRouteImport } from './routes/_authenticated/mentor-data-dashboard'
import { Route as AuthenticatedExportsRouteImport } from './routes/_authenticated/exports'
import { Route as AuthenticatedCareReviewsRouteImport } from './routes/_authenticated/care-reviews'
import { Route as AuthenticatedAvaRouteImport } from './routes/_authenticated/ava'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthDemoAccountsRouteImport } from './routes/_auth/demo-accounts'
import { Route as AuthAcceptInviteRouteImport } from './routes/_auth/accept-invite'
import { Route as Mentor_profileMentorProfileIndexRouteImport } from './routes/_mentor_profile/mentor-profile/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTrainingIndexRouteImport } from './routes/_authenticated/training/index'
import { Route as AuthenticatedSupportIndexRouteImport } from './routes/_authenticated/support/index'
import { Route as AuthenticatedSmsLifecycleIndexRouteImport } from './routes/_authenticated/sms-lifecycle/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedRiskFlaggingIndexRouteImport } from './routes/_authenticated/risk-flagging/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedOnboardingIndexRouteImport } from './routes/_authenticated/onboarding/index'
import { Route as AuthenticatedNewTeensIndexRouteImport } from './routes/_authenticated/new-teens/index'
import { Route as AuthenticatedMentorsIndexRouteImport } from './routes/_authenticated/mentors/index'
import { Route as AuthenticatedMentorScoringIndexRouteImport } from './routes/_authenticated/mentor-scoring/index'
import { Route as AuthenticatedMentorPerformanceIndexRouteImport } from './routes/_authenticated/mentor-performance/index'
import { Route as AuthenticatedMentorPayoutIndexRouteImport } from './routes/_authenticated/mentor-payout/index'
import { Route as AuthenticatedMentorForecastingIndexRouteImport } from './routes/_authenticated/mentor-forecasting/index'
import { Route as AuthenticatedKnowledgeBaseIndexRouteImport } from './routes/_authenticated/knowledge-base/index'
import { Route as AuthenticatedEscalationsIndexRouteImport } from './routes/_authenticated/escalations/index'
import { Route as AuthenticatedConversationsIndexRouteImport } from './routes/_authenticated/conversations/index'
import { Route as AuthenticatedChangelogIndexRouteImport } from './routes/_authenticated/changelog/index'
import { Route as AuthenticatedCampaignCodesIndexRouteImport } from './routes/_authenticated/campaign-codes/index'
import { Route as AuthenticatedAvaIndexRouteImport } from './routes/_authenticated/ava/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedRolesRoleIdRouteImport } from './routes/_authenticated/roles/$roleId'
import { Route as AuthenticatedProfileScheduleRouteImport } from './routes/_authenticated/profile/schedule'
import { Route as AuthenticatedProfileMatchingRouteImport } from './routes/_authenticated/profile/matching'
import { Route as AuthenticatedProfileFirstMomentsRouteImport } from './routes/_authenticated/profile/first-moments'
import { Route as AuthenticatedProfileAccountRouteImport } from './routes/_authenticated/profile/account'
import { Route as AuthenticatedMentorshipsMentorshipIdRouteImport } from './routes/_authenticated/mentorships/$mentorshipId'
import { Route as AuthenticatedMentorsSchedulesRouteImport } from './routes/_authenticated/mentors/schedules'
import { Route as AuthenticatedMentorScoringMentorIdRouteImport } from './routes/_authenticated/mentor-scoring/$mentorId'
import { Route as AuthenticatedMentorMonthlyUpdatesMentorshipIdRouteImport } from './routes/_authenticated/mentor-monthly-updates/$mentorshipId'
import { Route as AuthenticatedKnowledgeBaseNewRouteImport } from './routes/_authenticated/knowledge-base/new'
import { Route as AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRouteImport } from './routes/_authenticated/knowledge-base/$triggerKnowledgeBaseId'
import { Route as AuthenticatedCampaignCodesCodeIdRouteImport } from './routes/_authenticated/campaign-codes/$codeId'
import { Route as AuthenticatedCallsRoomIdRouteImport } from './routes/_authenticated/calls/$roomId'
import { Route as AuthenticatedAvaChatIdRouteImport } from './routes/_authenticated/ava/$chatId'
import { Route as Admin_chatChatMentorshipIdRouteImport } from './routes/_admin_chat/chat/$mentorshipId'
import { Route as AuthenticatedTrainingReviewIndexRouteImport } from './routes/_authenticated/training/review/index'
import { Route as AuthenticatedUsersMentorStoryReviewsReviewIdRouteImport } from './routes/_authenticated/users/mentor-story-reviews/$reviewId'
import { Route as AuthenticatedUsersMentorProfileReviewsReviewIdRouteImport } from './routes/_authenticated/users/mentor-profile-reviews/$reviewId'
import { Route as AuthenticatedTrainingSessionAttemptIdRouteImport } from './routes/_authenticated/training/session.$attemptId'
import { Route as AuthenticatedTrainingReviewProgressIdRouteImport } from './routes/_authenticated/training/review/$progressId'
import { Route as AuthenticatedTrainingCompleteAttemptIdRouteImport } from './routes/_authenticated/training/complete.$attemptId'
import { Route as AuthenticatedMentorScoringDetailsSnapshotIdRouteImport } from './routes/_authenticated/mentor-scoring/details/$snapshotId'

const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const Mentor_profileRoute = Mentor_profileRouteImport.update({
  id: '/_mentor_profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const Admin_chatRoute = Admin_chatRouteImport.update({
  id: '/_admin_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUpcomingRoute = AuthenticatedUpcomingRouteImport.update({
  id: '/upcoming',
  path: '/upcoming',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReferralsRoute = AuthenticatedReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMentorDataDashboardRoute =
  AuthenticatedMentorDataDashboardRouteImport.update({
    id: '/mentor-data-dashboard',
    path: '/mentor-data-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExportsRoute = AuthenticatedExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCareReviewsRoute =
  AuthenticatedCareReviewsRouteImport.update({
    id: '/care-reviews',
    path: '/care-reviews',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAvaRoute = AuthenticatedAvaRouteImport.update({
  id: '/ava',
  path: '/ava',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDemoAccountsRoute = AuthDemoAccountsRouteImport.update({
  id: '/demo-accounts',
  path: '/demo-accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAcceptInviteRoute = AuthAcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => AuthRoute,
} as any)
const Mentor_profileMentorProfileIndexRoute =
  Mentor_profileMentorProfileIndexRouteImport.update({
    id: '/mentor-profile/',
    path: '/mentor-profile/',
    getParentRoute: () => Mentor_profileRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTrainingIndexRoute =
  AuthenticatedTrainingIndexRouteImport.update({
    id: '/training/',
    path: '/training/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSupportIndexRoute =
  AuthenticatedSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSmsLifecycleIndexRoute =
  AuthenticatedSmsLifecycleIndexRouteImport.update({
    id: '/sms-lifecycle/',
    path: '/sms-lifecycle/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRiskFlaggingIndexRoute =
  AuthenticatedRiskFlaggingIndexRouteImport.update({
    id: '/risk-flagging/',
    path: '/risk-flagging/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedOnboardingIndexRoute =
  AuthenticatedOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNewTeensIndexRoute =
  AuthenticatedNewTeensIndexRouteImport.update({
    id: '/new-teens/',
    path: '/new-teens/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorsIndexRoute =
  AuthenticatedMentorsIndexRouteImport.update({
    id: '/mentors/',
    path: '/mentors/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorScoringIndexRoute =
  AuthenticatedMentorScoringIndexRouteImport.update({
    id: '/mentor-scoring/',
    path: '/mentor-scoring/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorPerformanceIndexRoute =
  AuthenticatedMentorPerformanceIndexRouteImport.update({
    id: '/mentor-performance/',
    path: '/mentor-performance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorPayoutIndexRoute =
  AuthenticatedMentorPayoutIndexRouteImport.update({
    id: '/mentor-payout/',
    path: '/mentor-payout/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorForecastingIndexRoute =
  AuthenticatedMentorForecastingIndexRouteImport.update({
    id: '/mentor-forecasting/',
    path: '/mentor-forecasting/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseIndexRoute =
  AuthenticatedKnowledgeBaseIndexRouteImport.update({
    id: '/knowledge-base/',
    path: '/knowledge-base/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEscalationsIndexRoute =
  AuthenticatedEscalationsIndexRouteImport.update({
    id: '/escalations/',
    path: '/escalations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConversationsIndexRoute =
  AuthenticatedConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChangelogIndexRoute =
  AuthenticatedChangelogIndexRouteImport.update({
    id: '/changelog/',
    path: '/changelog/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignCodesIndexRoute =
  AuthenticatedCampaignCodesIndexRouteImport.update({
    id: '/campaign-codes/',
    path: '/campaign-codes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAvaIndexRoute = AuthenticatedAvaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAvaRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesRoleIdRoute =
  AuthenticatedRolesRoleIdRouteImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileScheduleRoute =
  AuthenticatedProfileScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedProfileMatchingRoute =
  AuthenticatedProfileMatchingRouteImport.update({
    id: '/matching',
    path: '/matching',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedProfileFirstMomentsRoute =
  AuthenticatedProfileFirstMomentsRouteImport.update({
    id: '/first-moments',
    path: '/first-moments',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedProfileAccountRoute =
  AuthenticatedProfileAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedProfileRoute,
  } as any)
const AuthenticatedMentorshipsMentorshipIdRoute =
  AuthenticatedMentorshipsMentorshipIdRouteImport.update({
    id: '/mentorships/$mentorshipId',
    path: '/mentorships/$mentorshipId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorsSchedulesRoute =
  AuthenticatedMentorsSchedulesRouteImport.update({
    id: '/mentors/schedules',
    path: '/mentors/schedules',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorScoringMentorIdRoute =
  AuthenticatedMentorScoringMentorIdRouteImport.update({
    id: '/mentor-scoring/$mentorId',
    path: '/mentor-scoring/$mentorId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute =
  AuthenticatedMentorMonthlyUpdatesMentorshipIdRouteImport.update({
    id: '/mentor-monthly-updates/$mentorshipId',
    path: '/mentor-monthly-updates/$mentorshipId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseNewRoute =
  AuthenticatedKnowledgeBaseNewRouteImport.update({
    id: '/knowledge-base/new',
    path: '/knowledge-base/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute =
  AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRouteImport.update({
    id: '/knowledge-base/$triggerKnowledgeBaseId',
    path: '/knowledge-base/$triggerKnowledgeBaseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignCodesCodeIdRoute =
  AuthenticatedCampaignCodesCodeIdRouteImport.update({
    id: '/campaign-codes/$codeId',
    path: '/campaign-codes/$codeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallsRoomIdRoute =
  AuthenticatedCallsRoomIdRouteImport.update({
    id: '/calls/$roomId',
    path: '/calls/$roomId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAvaChatIdRoute = AuthenticatedAvaChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => AuthenticatedAvaRoute,
} as any)
const Admin_chatChatMentorshipIdRoute =
  Admin_chatChatMentorshipIdRouteImport.update({
    id: '/chat/$mentorshipId',
    path: '/chat/$mentorshipId',
    getParentRoute: () => Admin_chatRoute,
  } as any)
const AuthenticatedTrainingReviewIndexRoute =
  AuthenticatedTrainingReviewIndexRouteImport.update({
    id: '/training/review/',
    path: '/training/review/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersMentorStoryReviewsReviewIdRoute =
  AuthenticatedUsersMentorStoryReviewsReviewIdRouteImport.update({
    id: '/users/mentor-story-reviews/$reviewId',
    path: '/users/mentor-story-reviews/$reviewId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersMentorProfileReviewsReviewIdRoute =
  AuthenticatedUsersMentorProfileReviewsReviewIdRouteImport.update({
    id: '/users/mentor-profile-reviews/$reviewId',
    path: '/users/mentor-profile-reviews/$reviewId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTrainingSessionAttemptIdRoute =
  AuthenticatedTrainingSessionAttemptIdRouteImport.update({
    id: '/training/session/$attemptId',
    path: '/training/session/$attemptId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTrainingReviewProgressIdRoute =
  AuthenticatedTrainingReviewProgressIdRouteImport.update({
    id: '/training/review/$progressId',
    path: '/training/review/$progressId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTrainingCompleteAttemptIdRoute =
  AuthenticatedTrainingCompleteAttemptIdRouteImport.update({
    id: '/training/complete/$attemptId',
    path: '/training/complete/$attemptId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorScoringDetailsSnapshotIdRoute =
  AuthenticatedMentorScoringDetailsSnapshotIdRouteImport.update({
    id: '/mentor-scoring/details/$snapshotId',
    path: '/mentor-scoring/details/$snapshotId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/demo-accounts': typeof AuthDemoAccountsRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/ava': typeof AuthenticatedAvaRouteWithChildren
  '/care-reviews': typeof AuthenticatedCareReviewsRoute
  '/exports': typeof AuthenticatedExportsRoute
  '/mentor-data-dashboard': typeof AuthenticatedMentorDataDashboardRoute
  '/profile': typeof AuthenticatedProfileRouteWithChildren
  '/referrals': typeof AuthenticatedReferralsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upcoming': typeof AuthenticatedUpcomingRoute
  '/chat/$mentorshipId': typeof Admin_chatChatMentorshipIdRoute
  '/ava/$chatId': typeof AuthenticatedAvaChatIdRoute
  '/calls/$roomId': typeof AuthenticatedCallsRoomIdRoute
  '/campaign-codes/$codeId': typeof AuthenticatedCampaignCodesCodeIdRoute
  '/knowledge-base/$triggerKnowledgeBaseId': typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  '/knowledge-base/new': typeof AuthenticatedKnowledgeBaseNewRoute
  '/mentor-monthly-updates/$mentorshipId': typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  '/mentor-scoring/$mentorId': typeof AuthenticatedMentorScoringMentorIdRoute
  '/mentors/schedules': typeof AuthenticatedMentorsSchedulesRoute
  '/mentorships/$mentorshipId': typeof AuthenticatedMentorshipsMentorshipIdRoute
  '/profile/account': typeof AuthenticatedProfileAccountRoute
  '/profile/first-moments': typeof AuthenticatedProfileFirstMomentsRoute
  '/profile/matching': typeof AuthenticatedProfileMatchingRoute
  '/profile/schedule': typeof AuthenticatedProfileScheduleRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/ava/': typeof AuthenticatedAvaIndexRoute
  '/campaign-codes/': typeof AuthenticatedCampaignCodesIndexRoute
  '/changelog/': typeof AuthenticatedChangelogIndexRoute
  '/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/escalations/': typeof AuthenticatedEscalationsIndexRoute
  '/knowledge-base/': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/mentor-forecasting/': typeof AuthenticatedMentorForecastingIndexRoute
  '/mentor-payout/': typeof AuthenticatedMentorPayoutIndexRoute
  '/mentor-performance/': typeof AuthenticatedMentorPerformanceIndexRoute
  '/mentor-scoring/': typeof AuthenticatedMentorScoringIndexRoute
  '/mentors/': typeof AuthenticatedMentorsIndexRoute
  '/new-teens/': typeof AuthenticatedNewTeensIndexRoute
  '/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/risk-flagging/': typeof AuthenticatedRiskFlaggingIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/sms-lifecycle/': typeof AuthenticatedSmsLifecycleIndexRoute
  '/support/': typeof AuthenticatedSupportIndexRoute
  '/training/': typeof AuthenticatedTrainingIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/mentor-profile/': typeof Mentor_profileMentorProfileIndexRoute
  '/mentor-scoring/details/$snapshotId': typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
  '/training/complete/$attemptId': typeof AuthenticatedTrainingCompleteAttemptIdRoute
  '/training/review/$progressId': typeof AuthenticatedTrainingReviewProgressIdRoute
  '/training/session/$attemptId': typeof AuthenticatedTrainingSessionAttemptIdRoute
  '/users/mentor-profile-reviews/$reviewId': typeof AuthenticatedUsersMentorProfileReviewsReviewIdRoute
  '/users/mentor-story-reviews/$reviewId': typeof AuthenticatedUsersMentorStoryReviewsReviewIdRoute
  '/training/review/': typeof AuthenticatedTrainingReviewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/impersonate': typeof ImpersonateRoute
  '/accept-invite': typeof AuthAcceptInviteRoute
  '/demo-accounts': typeof AuthDemoAccountsRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/care-reviews': typeof AuthenticatedCareReviewsRoute
  '/exports': typeof AuthenticatedExportsRoute
  '/mentor-data-dashboard': typeof AuthenticatedMentorDataDashboardRoute
  '/referrals': typeof AuthenticatedReferralsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upcoming': typeof AuthenticatedUpcomingRoute
  '/chat/$mentorshipId': typeof Admin_chatChatMentorshipIdRoute
  '/ava/$chatId': typeof AuthenticatedAvaChatIdRoute
  '/calls/$roomId': typeof AuthenticatedCallsRoomIdRoute
  '/campaign-codes/$codeId': typeof AuthenticatedCampaignCodesCodeIdRoute
  '/knowledge-base/$triggerKnowledgeBaseId': typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  '/knowledge-base/new': typeof AuthenticatedKnowledgeBaseNewRoute
  '/mentor-monthly-updates/$mentorshipId': typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  '/mentor-scoring/$mentorId': typeof AuthenticatedMentorScoringMentorIdRoute
  '/mentors/schedules': typeof AuthenticatedMentorsSchedulesRoute
  '/mentorships/$mentorshipId': typeof AuthenticatedMentorshipsMentorshipIdRoute
  '/profile/account': typeof AuthenticatedProfileAccountRoute
  '/profile/first-moments': typeof AuthenticatedProfileFirstMomentsRoute
  '/profile/matching': typeof AuthenticatedProfileMatchingRoute
  '/profile/schedule': typeof AuthenticatedProfileScheduleRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/ava': typeof AuthenticatedAvaIndexRoute
  '/campaign-codes': typeof AuthenticatedCampaignCodesIndexRoute
  '/changelog': typeof AuthenticatedChangelogIndexRoute
  '/conversations': typeof AuthenticatedConversationsIndexRoute
  '/escalations': typeof AuthenticatedEscalationsIndexRoute
  '/knowledge-base': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/mentor-forecasting': typeof AuthenticatedMentorForecastingIndexRoute
  '/mentor-payout': typeof AuthenticatedMentorPayoutIndexRoute
  '/mentor-performance': typeof AuthenticatedMentorPerformanceIndexRoute
  '/mentor-scoring': typeof AuthenticatedMentorScoringIndexRoute
  '/mentors': typeof AuthenticatedMentorsIndexRoute
  '/new-teens': typeof AuthenticatedNewTeensIndexRoute
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/risk-flagging': typeof AuthenticatedRiskFlaggingIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/sms-lifecycle': typeof AuthenticatedSmsLifecycleIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
  '/training': typeof AuthenticatedTrainingIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/mentor-profile': typeof Mentor_profileMentorProfileIndexRoute
  '/mentor-scoring/details/$snapshotId': typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
  '/training/complete/$attemptId': typeof AuthenticatedTrainingCompleteAttemptIdRoute
  '/training/review/$progressId': typeof AuthenticatedTrainingReviewProgressIdRoute
  '/training/session/$attemptId': typeof AuthenticatedTrainingSessionAttemptIdRoute
  '/users/mentor-profile-reviews/$reviewId': typeof AuthenticatedUsersMentorProfileReviewsReviewIdRoute
  '/users/mentor-story-reviews/$reviewId': typeof AuthenticatedUsersMentorStoryReviewsReviewIdRoute
  '/training/review': typeof AuthenticatedTrainingReviewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin_chat': typeof Admin_chatRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_mentor_profile': typeof Mentor_profileRouteWithChildren
  '/impersonate': typeof ImpersonateRoute
  '/_auth/accept-invite': typeof AuthAcceptInviteRoute
  '/_auth/demo-accounts': typeof AuthDemoAccountsRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_authenticated/ava': typeof AuthenticatedAvaRouteWithChildren
  '/_authenticated/care-reviews': typeof AuthenticatedCareReviewsRoute
  '/_authenticated/exports': typeof AuthenticatedExportsRoute
  '/_authenticated/mentor-data-dashboard': typeof AuthenticatedMentorDataDashboardRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRouteWithChildren
  '/_authenticated/referrals': typeof AuthenticatedReferralsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/upcoming': typeof AuthenticatedUpcomingRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_admin_chat/chat/$mentorshipId': typeof Admin_chatChatMentorshipIdRoute
  '/_authenticated/ava/$chatId': typeof AuthenticatedAvaChatIdRoute
  '/_authenticated/calls/$roomId': typeof AuthenticatedCallsRoomIdRoute
  '/_authenticated/campaign-codes/$codeId': typeof AuthenticatedCampaignCodesCodeIdRoute
  '/_authenticated/knowledge-base/$triggerKnowledgeBaseId': typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  '/_authenticated/knowledge-base/new': typeof AuthenticatedKnowledgeBaseNewRoute
  '/_authenticated/mentor-monthly-updates/$mentorshipId': typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  '/_authenticated/mentor-scoring/$mentorId': typeof AuthenticatedMentorScoringMentorIdRoute
  '/_authenticated/mentors/schedules': typeof AuthenticatedMentorsSchedulesRoute
  '/_authenticated/mentorships/$mentorshipId': typeof AuthenticatedMentorshipsMentorshipIdRoute
  '/_authenticated/profile/account': typeof AuthenticatedProfileAccountRoute
  '/_authenticated/profile/first-moments': typeof AuthenticatedProfileFirstMomentsRoute
  '/_authenticated/profile/matching': typeof AuthenticatedProfileMatchingRoute
  '/_authenticated/profile/schedule': typeof AuthenticatedProfileScheduleRoute
  '/_authenticated/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/ava/': typeof AuthenticatedAvaIndexRoute
  '/_authenticated/campaign-codes/': typeof AuthenticatedCampaignCodesIndexRoute
  '/_authenticated/changelog/': typeof AuthenticatedChangelogIndexRoute
  '/_authenticated/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/_authenticated/escalations/': typeof AuthenticatedEscalationsIndexRoute
  '/_authenticated/knowledge-base/': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/_authenticated/mentor-forecasting/': typeof AuthenticatedMentorForecastingIndexRoute
  '/_authenticated/mentor-payout/': typeof AuthenticatedMentorPayoutIndexRoute
  '/_authenticated/mentor-performance/': typeof AuthenticatedMentorPerformanceIndexRoute
  '/_authenticated/mentor-scoring/': typeof AuthenticatedMentorScoringIndexRoute
  '/_authenticated/mentors/': typeof AuthenticatedMentorsIndexRoute
  '/_authenticated/new-teens/': typeof AuthenticatedNewTeensIndexRoute
  '/_authenticated/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/risk-flagging/': typeof AuthenticatedRiskFlaggingIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/sms-lifecycle/': typeof AuthenticatedSmsLifecycleIndexRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexRoute
  '/_authenticated/training/': typeof AuthenticatedTrainingIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_mentor_profile/mentor-profile/': typeof Mentor_profileMentorProfileIndexRoute
  '/_authenticated/mentor-scoring/details/$snapshotId': typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
  '/_authenticated/training/complete/$attemptId': typeof AuthenticatedTrainingCompleteAttemptIdRoute
  '/_authenticated/training/review/$progressId': typeof AuthenticatedTrainingReviewProgressIdRoute
  '/_authenticated/training/session/$attemptId': typeof AuthenticatedTrainingSessionAttemptIdRoute
  '/_authenticated/users/mentor-profile-reviews/$reviewId': typeof AuthenticatedUsersMentorProfileReviewsReviewIdRoute
  '/_authenticated/users/mentor-story-reviews/$reviewId': typeof AuthenticatedUsersMentorStoryReviewsReviewIdRoute
  '/_authenticated/training/review/': typeof AuthenticatedTrainingReviewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/impersonate'
    | '/accept-invite'
    | '/demo-accounts'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/ava'
    | '/care-reviews'
    | '/exports'
    | '/mentor-data-dashboard'
    | '/profile'
    | '/referrals'
    | '/settings'
    | '/upcoming'
    | '/chat/$mentorshipId'
    | '/ava/$chatId'
    | '/calls/$roomId'
    | '/campaign-codes/$codeId'
    | '/knowledge-base/$triggerKnowledgeBaseId'
    | '/knowledge-base/new'
    | '/mentor-monthly-updates/$mentorshipId'
    | '/mentor-scoring/$mentorId'
    | '/mentors/schedules'
    | '/mentorships/$mentorshipId'
    | '/profile/account'
    | '/profile/first-moments'
    | '/profile/matching'
    | '/profile/schedule'
    | '/roles/$roleId'
    | '/users/$userId'
    | '/ava/'
    | '/campaign-codes/'
    | '/changelog/'
    | '/conversations/'
    | '/escalations/'
    | '/knowledge-base/'
    | '/mentor-forecasting/'
    | '/mentor-payout/'
    | '/mentor-performance/'
    | '/mentor-scoring/'
    | '/mentors/'
    | '/new-teens/'
    | '/onboarding/'
    | '/profile/'
    | '/risk-flagging/'
    | '/roles/'
    | '/sms-lifecycle/'
    | '/support/'
    | '/training/'
    | '/users/'
    | '/mentor-profile/'
    | '/mentor-scoring/details/$snapshotId'
    | '/training/complete/$attemptId'
    | '/training/review/$progressId'
    | '/training/session/$attemptId'
    | '/users/mentor-profile-reviews/$reviewId'
    | '/users/mentor-story-reviews/$reviewId'
    | '/training/review/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/impersonate'
    | '/accept-invite'
    | '/demo-accounts'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/care-reviews'
    | '/exports'
    | '/mentor-data-dashboard'
    | '/referrals'
    | '/settings'
    | '/upcoming'
    | '/chat/$mentorshipId'
    | '/ava/$chatId'
    | '/calls/$roomId'
    | '/campaign-codes/$codeId'
    | '/knowledge-base/$triggerKnowledgeBaseId'
    | '/knowledge-base/new'
    | '/mentor-monthly-updates/$mentorshipId'
    | '/mentor-scoring/$mentorId'
    | '/mentors/schedules'
    | '/mentorships/$mentorshipId'
    | '/profile/account'
    | '/profile/first-moments'
    | '/profile/matching'
    | '/profile/schedule'
    | '/roles/$roleId'
    | '/users/$userId'
    | '/ava'
    | '/campaign-codes'
    | '/changelog'
    | '/conversations'
    | '/escalations'
    | '/knowledge-base'
    | '/mentor-forecasting'
    | '/mentor-payout'
    | '/mentor-performance'
    | '/mentor-scoring'
    | '/mentors'
    | '/new-teens'
    | '/onboarding'
    | '/profile'
    | '/risk-flagging'
    | '/roles'
    | '/sms-lifecycle'
    | '/support'
    | '/training'
    | '/users'
    | '/mentor-profile'
    | '/mentor-scoring/details/$snapshotId'
    | '/training/complete/$attemptId'
    | '/training/review/$progressId'
    | '/training/session/$attemptId'
    | '/users/mentor-profile-reviews/$reviewId'
    | '/users/mentor-story-reviews/$reviewId'
    | '/training/review'
  id:
    | '__root__'
    | '/_admin_chat'
    | '/_auth'
    | '/_authenticated'
    | '/_mentor_profile'
    | '/impersonate'
    | '/_auth/accept-invite'
    | '/_auth/demo-accounts'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/_authenticated/ava'
    | '/_authenticated/care-reviews'
    | '/_authenticated/exports'
    | '/_authenticated/mentor-data-dashboard'
    | '/_authenticated/profile'
    | '/_authenticated/referrals'
    | '/_authenticated/settings'
    | '/_authenticated/upcoming'
    | '/_authenticated/'
    | '/_admin_chat/chat/$mentorshipId'
    | '/_authenticated/ava/$chatId'
    | '/_authenticated/calls/$roomId'
    | '/_authenticated/campaign-codes/$codeId'
    | '/_authenticated/knowledge-base/$triggerKnowledgeBaseId'
    | '/_authenticated/knowledge-base/new'
    | '/_authenticated/mentor-monthly-updates/$mentorshipId'
    | '/_authenticated/mentor-scoring/$mentorId'
    | '/_authenticated/mentors/schedules'
    | '/_authenticated/mentorships/$mentorshipId'
    | '/_authenticated/profile/account'
    | '/_authenticated/profile/first-moments'
    | '/_authenticated/profile/matching'
    | '/_authenticated/profile/schedule'
    | '/_authenticated/roles/$roleId'
    | '/_authenticated/users/$userId'
    | '/_authenticated/ava/'
    | '/_authenticated/campaign-codes/'
    | '/_authenticated/changelog/'
    | '/_authenticated/conversations/'
    | '/_authenticated/escalations/'
    | '/_authenticated/knowledge-base/'
    | '/_authenticated/mentor-forecasting/'
    | '/_authenticated/mentor-payout/'
    | '/_authenticated/mentor-performance/'
    | '/_authenticated/mentor-scoring/'
    | '/_authenticated/mentors/'
    | '/_authenticated/new-teens/'
    | '/_authenticated/onboarding/'
    | '/_authenticated/profile/'
    | '/_authenticated/risk-flagging/'
    | '/_authenticated/roles/'
    | '/_authenticated/sms-lifecycle/'
    | '/_authenticated/support/'
    | '/_authenticated/training/'
    | '/_authenticated/users/'
    | '/_mentor_profile/mentor-profile/'
    | '/_authenticated/mentor-scoring/details/$snapshotId'
    | '/_authenticated/training/complete/$attemptId'
    | '/_authenticated/training/review/$progressId'
    | '/_authenticated/training/session/$attemptId'
    | '/_authenticated/users/mentor-profile-reviews/$reviewId'
    | '/_authenticated/users/mentor-story-reviews/$reviewId'
    | '/_authenticated/training/review/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Admin_chatRoute: typeof Admin_chatRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  Mentor_profileRoute: typeof Mentor_profileRouteWithChildren
  ImpersonateRoute: typeof ImpersonateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_mentor_profile': {
      id: '/_mentor_profile'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof Mentor_profileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin_chat': {
      id: '/_admin_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof Admin_chatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upcoming': {
      id: '/_authenticated/upcoming'
      path: '/upcoming'
      fullPath: '/upcoming'
      preLoaderRoute: typeof AuthenticatedUpcomingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/referrals': {
      id: '/_authenticated/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthenticatedReferralsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-data-dashboard': {
      id: '/_authenticated/mentor-data-dashboard'
      path: '/mentor-data-dashboard'
      fullPath: '/mentor-data-dashboard'
      preLoaderRoute: typeof AuthenticatedMentorDataDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exports': {
      id: '/_authenticated/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof AuthenticatedExportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/care-reviews': {
      id: '/_authenticated/care-reviews'
      path: '/care-reviews'
      fullPath: '/care-reviews'
      preLoaderRoute: typeof AuthenticatedCareReviewsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ava': {
      id: '/_authenticated/ava'
      path: '/ava'
      fullPath: '/ava'
      preLoaderRoute: typeof AuthenticatedAvaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demo-accounts': {
      id: '/_auth/demo-accounts'
      path: '/demo-accounts'
      fullPath: '/demo-accounts'
      preLoaderRoute: typeof AuthDemoAccountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accept-invite': {
      id: '/_auth/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AuthAcceptInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_mentor_profile/mentor-profile/': {
      id: '/_mentor_profile/mentor-profile/'
      path: '/mentor-profile'
      fullPath: '/mentor-profile/'
      preLoaderRoute: typeof Mentor_profileMentorProfileIndexRouteImport
      parentRoute: typeof Mentor_profileRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/training/': {
      id: '/_authenticated/training/'
      path: '/training'
      fullPath: '/training/'
      preLoaderRoute: typeof AuthenticatedTrainingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthenticatedSupportIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sms-lifecycle/': {
      id: '/_authenticated/sms-lifecycle/'
      path: '/sms-lifecycle'
      fullPath: '/sms-lifecycle/'
      preLoaderRoute: typeof AuthenticatedSmsLifecycleIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/risk-flagging/': {
      id: '/_authenticated/risk-flagging/'
      path: '/risk-flagging'
      fullPath: '/risk-flagging/'
      preLoaderRoute: typeof AuthenticatedRiskFlaggingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/onboarding/': {
      id: '/_authenticated/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthenticatedOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/new-teens/': {
      id: '/_authenticated/new-teens/'
      path: '/new-teens'
      fullPath: '/new-teens/'
      preLoaderRoute: typeof AuthenticatedNewTeensIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentors/': {
      id: '/_authenticated/mentors/'
      path: '/mentors'
      fullPath: '/mentors/'
      preLoaderRoute: typeof AuthenticatedMentorsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-scoring/': {
      id: '/_authenticated/mentor-scoring/'
      path: '/mentor-scoring'
      fullPath: '/mentor-scoring/'
      preLoaderRoute: typeof AuthenticatedMentorScoringIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-performance/': {
      id: '/_authenticated/mentor-performance/'
      path: '/mentor-performance'
      fullPath: '/mentor-performance/'
      preLoaderRoute: typeof AuthenticatedMentorPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-payout/': {
      id: '/_authenticated/mentor-payout/'
      path: '/mentor-payout'
      fullPath: '/mentor-payout/'
      preLoaderRoute: typeof AuthenticatedMentorPayoutIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-forecasting/': {
      id: '/_authenticated/mentor-forecasting/'
      path: '/mentor-forecasting'
      fullPath: '/mentor-forecasting/'
      preLoaderRoute: typeof AuthenticatedMentorForecastingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/': {
      id: '/_authenticated/knowledge-base/'
      path: '/knowledge-base'
      fullPath: '/knowledge-base/'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/escalations/': {
      id: '/_authenticated/escalations/'
      path: '/escalations'
      fullPath: '/escalations/'
      preLoaderRoute: typeof AuthenticatedEscalationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations/': {
      id: '/_authenticated/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AuthenticatedConversationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/changelog/': {
      id: '/_authenticated/changelog/'
      path: '/changelog'
      fullPath: '/changelog/'
      preLoaderRoute: typeof AuthenticatedChangelogIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign-codes/': {
      id: '/_authenticated/campaign-codes/'
      path: '/campaign-codes'
      fullPath: '/campaign-codes/'
      preLoaderRoute: typeof AuthenticatedCampaignCodesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ava/': {
      id: '/_authenticated/ava/'
      path: '/'
      fullPath: '/ava/'
      preLoaderRoute: typeof AuthenticatedAvaIndexRouteImport
      parentRoute: typeof AuthenticatedAvaRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/$roleId': {
      id: '/_authenticated/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/schedule': {
      id: '/_authenticated/profile/schedule'
      path: '/schedule'
      fullPath: '/profile/schedule'
      preLoaderRoute: typeof AuthenticatedProfileScheduleRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/profile/matching': {
      id: '/_authenticated/profile/matching'
      path: '/matching'
      fullPath: '/profile/matching'
      preLoaderRoute: typeof AuthenticatedProfileMatchingRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/profile/first-moments': {
      id: '/_authenticated/profile/first-moments'
      path: '/first-moments'
      fullPath: '/profile/first-moments'
      preLoaderRoute: typeof AuthenticatedProfileFirstMomentsRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/profile/account': {
      id: '/_authenticated/profile/account'
      path: '/account'
      fullPath: '/profile/account'
      preLoaderRoute: typeof AuthenticatedProfileAccountRouteImport
      parentRoute: typeof AuthenticatedProfileRoute
    }
    '/_authenticated/mentorships/$mentorshipId': {
      id: '/_authenticated/mentorships/$mentorshipId'
      path: '/mentorships/$mentorshipId'
      fullPath: '/mentorships/$mentorshipId'
      preLoaderRoute: typeof AuthenticatedMentorshipsMentorshipIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentors/schedules': {
      id: '/_authenticated/mentors/schedules'
      path: '/mentors/schedules'
      fullPath: '/mentors/schedules'
      preLoaderRoute: typeof AuthenticatedMentorsSchedulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-scoring/$mentorId': {
      id: '/_authenticated/mentor-scoring/$mentorId'
      path: '/mentor-scoring/$mentorId'
      fullPath: '/mentor-scoring/$mentorId'
      preLoaderRoute: typeof AuthenticatedMentorScoringMentorIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-monthly-updates/$mentorshipId': {
      id: '/_authenticated/mentor-monthly-updates/$mentorshipId'
      path: '/mentor-monthly-updates/$mentorshipId'
      fullPath: '/mentor-monthly-updates/$mentorshipId'
      preLoaderRoute: typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/new': {
      id: '/_authenticated/knowledge-base/new'
      path: '/knowledge-base/new'
      fullPath: '/knowledge-base/new'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/$triggerKnowledgeBaseId': {
      id: '/_authenticated/knowledge-base/$triggerKnowledgeBaseId'
      path: '/knowledge-base/$triggerKnowledgeBaseId'
      fullPath: '/knowledge-base/$triggerKnowledgeBaseId'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign-codes/$codeId': {
      id: '/_authenticated/campaign-codes/$codeId'
      path: '/campaign-codes/$codeId'
      fullPath: '/campaign-codes/$codeId'
      preLoaderRoute: typeof AuthenticatedCampaignCodesCodeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calls/$roomId': {
      id: '/_authenticated/calls/$roomId'
      path: '/calls/$roomId'
      fullPath: '/calls/$roomId'
      preLoaderRoute: typeof AuthenticatedCallsRoomIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ava/$chatId': {
      id: '/_authenticated/ava/$chatId'
      path: '/$chatId'
      fullPath: '/ava/$chatId'
      preLoaderRoute: typeof AuthenticatedAvaChatIdRouteImport
      parentRoute: typeof AuthenticatedAvaRoute
    }
    '/_admin_chat/chat/$mentorshipId': {
      id: '/_admin_chat/chat/$mentorshipId'
      path: '/chat/$mentorshipId'
      fullPath: '/chat/$mentorshipId'
      preLoaderRoute: typeof Admin_chatChatMentorshipIdRouteImport
      parentRoute: typeof Admin_chatRoute
    }
    '/_authenticated/training/review/': {
      id: '/_authenticated/training/review/'
      path: '/training/review'
      fullPath: '/training/review/'
      preLoaderRoute: typeof AuthenticatedTrainingReviewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/mentor-story-reviews/$reviewId': {
      id: '/_authenticated/users/mentor-story-reviews/$reviewId'
      path: '/users/mentor-story-reviews/$reviewId'
      fullPath: '/users/mentor-story-reviews/$reviewId'
      preLoaderRoute: typeof AuthenticatedUsersMentorStoryReviewsReviewIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/mentor-profile-reviews/$reviewId': {
      id: '/_authenticated/users/mentor-profile-reviews/$reviewId'
      path: '/users/mentor-profile-reviews/$reviewId'
      fullPath: '/users/mentor-profile-reviews/$reviewId'
      preLoaderRoute: typeof AuthenticatedUsersMentorProfileReviewsReviewIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/training/session/$attemptId': {
      id: '/_authenticated/training/session/$attemptId'
      path: '/training/session/$attemptId'
      fullPath: '/training/session/$attemptId'
      preLoaderRoute: typeof AuthenticatedTrainingSessionAttemptIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/training/review/$progressId': {
      id: '/_authenticated/training/review/$progressId'
      path: '/training/review/$progressId'
      fullPath: '/training/review/$progressId'
      preLoaderRoute: typeof AuthenticatedTrainingReviewProgressIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/training/complete/$attemptId': {
      id: '/_authenticated/training/complete/$attemptId'
      path: '/training/complete/$attemptId'
      fullPath: '/training/complete/$attemptId'
      preLoaderRoute: typeof AuthenticatedTrainingCompleteAttemptIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-scoring/details/$snapshotId': {
      id: '/_authenticated/mentor-scoring/details/$snapshotId'
      path: '/mentor-scoring/details/$snapshotId'
      fullPath: '/mentor-scoring/details/$snapshotId'
      preLoaderRoute: typeof AuthenticatedMentorScoringDetailsSnapshotIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface Admin_chatRouteChildren {
  Admin_chatChatMentorshipIdRoute: typeof Admin_chatChatMentorshipIdRoute
}

const Admin_chatRouteChildren: Admin_chatRouteChildren = {
  Admin_chatChatMentorshipIdRoute: Admin_chatChatMentorshipIdRoute,
}

const Admin_chatRouteWithChildren = Admin_chatRoute._addFileChildren(
  Admin_chatRouteChildren,
)

interface AuthRouteChildren {
  AuthAcceptInviteRoute: typeof AuthAcceptInviteRoute
  AuthDemoAccountsRoute: typeof AuthDemoAccountsRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAcceptInviteRoute: AuthAcceptInviteRoute,
  AuthDemoAccountsRoute: AuthDemoAccountsRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedAvaRouteChildren {
  AuthenticatedAvaChatIdRoute: typeof AuthenticatedAvaChatIdRoute
  AuthenticatedAvaIndexRoute: typeof AuthenticatedAvaIndexRoute
}

const AuthenticatedAvaRouteChildren: AuthenticatedAvaRouteChildren = {
  AuthenticatedAvaChatIdRoute: AuthenticatedAvaChatIdRoute,
  AuthenticatedAvaIndexRoute: AuthenticatedAvaIndexRoute,
}

const AuthenticatedAvaRouteWithChildren =
  AuthenticatedAvaRoute._addFileChildren(AuthenticatedAvaRouteChildren)

interface AuthenticatedProfileRouteChildren {
  AuthenticatedProfileAccountRoute: typeof AuthenticatedProfileAccountRoute
  AuthenticatedProfileFirstMomentsRoute: typeof AuthenticatedProfileFirstMomentsRoute
  AuthenticatedProfileMatchingRoute: typeof AuthenticatedProfileMatchingRoute
  AuthenticatedProfileScheduleRoute: typeof AuthenticatedProfileScheduleRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
}

const AuthenticatedProfileRouteChildren: AuthenticatedProfileRouteChildren = {
  AuthenticatedProfileAccountRoute: AuthenticatedProfileAccountRoute,
  AuthenticatedProfileFirstMomentsRoute: AuthenticatedProfileFirstMomentsRoute,
  AuthenticatedProfileMatchingRoute: AuthenticatedProfileMatchingRoute,
  AuthenticatedProfileScheduleRoute: AuthenticatedProfileScheduleRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
}

const AuthenticatedProfileRouteWithChildren =
  AuthenticatedProfileRoute._addFileChildren(AuthenticatedProfileRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAvaRoute: typeof AuthenticatedAvaRouteWithChildren
  AuthenticatedCareReviewsRoute: typeof AuthenticatedCareReviewsRoute
  AuthenticatedExportsRoute: typeof AuthenticatedExportsRoute
  AuthenticatedMentorDataDashboardRoute: typeof AuthenticatedMentorDataDashboardRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRouteWithChildren
  AuthenticatedReferralsRoute: typeof AuthenticatedReferralsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedUpcomingRoute: typeof AuthenticatedUpcomingRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCallsRoomIdRoute: typeof AuthenticatedCallsRoomIdRoute
  AuthenticatedCampaignCodesCodeIdRoute: typeof AuthenticatedCampaignCodesCodeIdRoute
  AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute: typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  AuthenticatedKnowledgeBaseNewRoute: typeof AuthenticatedKnowledgeBaseNewRoute
  AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute: typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  AuthenticatedMentorScoringMentorIdRoute: typeof AuthenticatedMentorScoringMentorIdRoute
  AuthenticatedMentorsSchedulesRoute: typeof AuthenticatedMentorsSchedulesRoute
  AuthenticatedMentorshipsMentorshipIdRoute: typeof AuthenticatedMentorshipsMentorshipIdRoute
  AuthenticatedRolesRoleIdRoute: typeof AuthenticatedRolesRoleIdRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedCampaignCodesIndexRoute: typeof AuthenticatedCampaignCodesIndexRoute
  AuthenticatedChangelogIndexRoute: typeof AuthenticatedChangelogIndexRoute
  AuthenticatedConversationsIndexRoute: typeof AuthenticatedConversationsIndexRoute
  AuthenticatedEscalationsIndexRoute: typeof AuthenticatedEscalationsIndexRoute
  AuthenticatedKnowledgeBaseIndexRoute: typeof AuthenticatedKnowledgeBaseIndexRoute
  AuthenticatedMentorForecastingIndexRoute: typeof AuthenticatedMentorForecastingIndexRoute
  AuthenticatedMentorPayoutIndexRoute: typeof AuthenticatedMentorPayoutIndexRoute
  AuthenticatedMentorPerformanceIndexRoute: typeof AuthenticatedMentorPerformanceIndexRoute
  AuthenticatedMentorScoringIndexRoute: typeof AuthenticatedMentorScoringIndexRoute
  AuthenticatedMentorsIndexRoute: typeof AuthenticatedMentorsIndexRoute
  AuthenticatedNewTeensIndexRoute: typeof AuthenticatedNewTeensIndexRoute
  AuthenticatedOnboardingIndexRoute: typeof AuthenticatedOnboardingIndexRoute
  AuthenticatedRiskFlaggingIndexRoute: typeof AuthenticatedRiskFlaggingIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedSmsLifecycleIndexRoute: typeof AuthenticatedSmsLifecycleIndexRoute
  AuthenticatedSupportIndexRoute: typeof AuthenticatedSupportIndexRoute
  AuthenticatedTrainingIndexRoute: typeof AuthenticatedTrainingIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedMentorScoringDetailsSnapshotIdRoute: typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
  AuthenticatedTrainingCompleteAttemptIdRoute: typeof AuthenticatedTrainingCompleteAttemptIdRoute
  AuthenticatedTrainingReviewProgressIdRoute: typeof AuthenticatedTrainingReviewProgressIdRoute
  AuthenticatedTrainingSessionAttemptIdRoute: typeof AuthenticatedTrainingSessionAttemptIdRoute
  AuthenticatedUsersMentorProfileReviewsReviewIdRoute: typeof AuthenticatedUsersMentorProfileReviewsReviewIdRoute
  AuthenticatedUsersMentorStoryReviewsReviewIdRoute: typeof AuthenticatedUsersMentorStoryReviewsReviewIdRoute
  AuthenticatedTrainingReviewIndexRoute: typeof AuthenticatedTrainingReviewIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAvaRoute: AuthenticatedAvaRouteWithChildren,
  AuthenticatedCareReviewsRoute: AuthenticatedCareReviewsRoute,
  AuthenticatedExportsRoute: AuthenticatedExportsRoute,
  AuthenticatedMentorDataDashboardRoute: AuthenticatedMentorDataDashboardRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRouteWithChildren,
  AuthenticatedReferralsRoute: AuthenticatedReferralsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedUpcomingRoute: AuthenticatedUpcomingRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCallsRoomIdRoute: AuthenticatedCallsRoomIdRoute,
  AuthenticatedCampaignCodesCodeIdRoute: AuthenticatedCampaignCodesCodeIdRoute,
  AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute:
    AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute,
  AuthenticatedKnowledgeBaseNewRoute: AuthenticatedKnowledgeBaseNewRoute,
  AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute:
    AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute,
  AuthenticatedMentorScoringMentorIdRoute:
    AuthenticatedMentorScoringMentorIdRoute,
  AuthenticatedMentorsSchedulesRoute: AuthenticatedMentorsSchedulesRoute,
  AuthenticatedMentorshipsMentorshipIdRoute:
    AuthenticatedMentorshipsMentorshipIdRoute,
  AuthenticatedRolesRoleIdRoute: AuthenticatedRolesRoleIdRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedCampaignCodesIndexRoute: AuthenticatedCampaignCodesIndexRoute,
  AuthenticatedChangelogIndexRoute: AuthenticatedChangelogIndexRoute,
  AuthenticatedConversationsIndexRoute: AuthenticatedConversationsIndexRoute,
  AuthenticatedEscalationsIndexRoute: AuthenticatedEscalationsIndexRoute,
  AuthenticatedKnowledgeBaseIndexRoute: AuthenticatedKnowledgeBaseIndexRoute,
  AuthenticatedMentorForecastingIndexRoute:
    AuthenticatedMentorForecastingIndexRoute,
  AuthenticatedMentorPayoutIndexRoute: AuthenticatedMentorPayoutIndexRoute,
  AuthenticatedMentorPerformanceIndexRoute:
    AuthenticatedMentorPerformanceIndexRoute,
  AuthenticatedMentorScoringIndexRoute: AuthenticatedMentorScoringIndexRoute,
  AuthenticatedMentorsIndexRoute: AuthenticatedMentorsIndexRoute,
  AuthenticatedNewTeensIndexRoute: AuthenticatedNewTeensIndexRoute,
  AuthenticatedOnboardingIndexRoute: AuthenticatedOnboardingIndexRoute,
  AuthenticatedRiskFlaggingIndexRoute: AuthenticatedRiskFlaggingIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedSmsLifecycleIndexRoute: AuthenticatedSmsLifecycleIndexRoute,
  AuthenticatedSupportIndexRoute: AuthenticatedSupportIndexRoute,
  AuthenticatedTrainingIndexRoute: AuthenticatedTrainingIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedMentorScoringDetailsSnapshotIdRoute:
    AuthenticatedMentorScoringDetailsSnapshotIdRoute,
  AuthenticatedTrainingCompleteAttemptIdRoute:
    AuthenticatedTrainingCompleteAttemptIdRoute,
  AuthenticatedTrainingReviewProgressIdRoute:
    AuthenticatedTrainingReviewProgressIdRoute,
  AuthenticatedTrainingSessionAttemptIdRoute:
    AuthenticatedTrainingSessionAttemptIdRoute,
  AuthenticatedUsersMentorProfileReviewsReviewIdRoute:
    AuthenticatedUsersMentorProfileReviewsReviewIdRoute,
  AuthenticatedUsersMentorStoryReviewsReviewIdRoute:
    AuthenticatedUsersMentorStoryReviewsReviewIdRoute,
  AuthenticatedTrainingReviewIndexRoute: AuthenticatedTrainingReviewIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface Mentor_profileRouteChildren {
  Mentor_profileMentorProfileIndexRoute: typeof Mentor_profileMentorProfileIndexRoute
}

const Mentor_profileRouteChildren: Mentor_profileRouteChildren = {
  Mentor_profileMentorProfileIndexRoute: Mentor_profileMentorProfileIndexRoute,
}

const Mentor_profileRouteWithChildren = Mentor_profileRoute._addFileChildren(
  Mentor_profileRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  Admin_chatRoute: Admin_chatRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  Mentor_profileRoute: Mentor_profileRouteWithChildren,
  ImpersonateRoute: ImpersonateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
